import { render } from "./ModifInfos.vue?vue&type=template&id=54163317"
import script from "./ModifInfos.vue?vue&type=script&lang=js"
export * from "./ModifInfos.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phl/phlsupport/deploy-support-cli/front_vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__